<template>
  <div>
    <el-card style="min-height: 200px; padding: 20px" v-loading="loading" shadow="never">
      <div v-if="editModel && !errorMsg">
        <el-form
          ref="form"
          :size="$xUISize"
          :model="editModel"
          :rules="editRules"
          @submit.native.prevent
          label-width="auto"
          label-position="top"
        >
          <el-form-item v-if="editModel.storeInfo" label="调研门店" prop="storeGuid">
            <span style="color: #919191"> {{ editModel.storeInfo.name }}</span>
          </el-form-item>
          <el-form-item label="调研标题" prop="surveyTitle">
            <el-input
              type="textarea"
              v-model="editModel.surveyTitle"
              :rows="2"
              maxlength="256"
              placeholder="输入调研标题信息"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="调研清单" prop="itemList">
            <div style="padding: 0px">
              <el-table
                stripe
                v-if="editModel.itemList && editModel.itemList.length > 0"
                :data="editModel.itemList"
                :cell-class-name="delLine"
                :size="$xUISize"
              >
                <el-table-column label="商品信息" min-width="380px">
                  <template slot-scope="scope">
                    <div style="margin-right: 10px">
                      <goods-sku-info :skuInfo="scope.row.skuInfo" />
                      <div v-if="scope.row.mtReportContent">
                        美团截图
                        <x-upload
                          type="image"
                          imageAlign="start"
                          style="margin-top: 10px"
                          :fileCount="20"
                          :imageViewWidth="80"
                          :imageViewHeight="80"
                          :disabled="true"
                          v-model="scope.row.mtReportContent"
                        ></x-upload>
                      </div>
                      <div v-if="scope.row.elmReportContent">
                        饿了么截图
                        <x-upload
                          type="image"
                          imageAlign="start"
                          style="margin-top: 10px"
                          :fileCount="20"
                          :imageViewWidth="80"
                          :imageViewHeight="80"
                          :disabled="true"
                          v-model="scope.row.elmReportContent"
                        ></x-upload>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="120px">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="danger"
                      v-if="!scope.row.guid"
                      @click="removeItemClick(scope.row)"
                    >
                      移出
                    </el-button>
                    <el-link
                      v-if="scope.row.guid"
                      :type="scope.row.isDelete ? 'primary' : 'danger'"
                      :underline="false"
                      @click="deleteItemClick(scope.row)"
                    >
                      {{ scope.row.isDelete ? "取消删除" : "标记删除" }}
                    </el-link>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
          <el-form-item label="备注说明" prop="optRemark">
            <el-input
              type="textarea"
              v-model="editModel.optRemark"
              :rows="3"
              maxlength="256"
              placeholder="输入备注说明内容"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              :loading="editSubmit"
              :disabled="
                editSubmit || !editModel.itemList || editModel.itemList.length <= 0
              "
              @click="submitClick"
            >
              提交
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-empty
        v-else-if="!loading && errorMsg"
        :description="errorMsg"
        :image-size="100"
      >
        <el-button v-if="errorMsg" @click="fetchModel" size="small"> 重新加载 </el-button>
      </el-empty>
    </el-card>
  </div>
</template>

<script>
import goodsSkuInfo from "../../../../components/business/goodsSkuInfo.vue";
import goodsSkuSelect from "../../../../components/business/goodsSkuSelect.vue";

const defaultModel = {
  itemList: [],
  paymentAmount: "",
  paymentAccount: "下单未支付",
  storeGuidList: "",
  freightAmount: 0,
  totalAmount: 0,
};

export default {
  components: {
    goodsSkuInfo,
    goodsSkuSelect,
  },
  props: {
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      editSubmit: false,
      editModel: null,
      editRules: {
        storeGuid: [
          {
            required: true,
            message: "请选择门店或仓库",
            trigger: "change",
          },
        ],
        surveyTitle: [
          {
            required: true,
            message: "调研标题不能为空",
            trigger: "change",
          },
        ],
        itemList: [
          {
            validator: (rule, value, callback) => {
              callback();
            },
            required: true,
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    delLine({ row, column, rowIndex, columnIndex }) {
      if (row.isDelete) return "del_line";
    },
    validate() {
      if (this.$refs.form) {
        this.$refs.form.validate();
      }
    },
    deleteItemClick(item) {
      item.isDelete = item.isDelete ? 0 : 1;
      this.handleItemChange();
    },
    removeItemClick(row) {
      if (!this.editModel.itemList) {
        this.editModel.itemList = [];
      }
      let indexOf = -1;
      this.editModel.itemList.forEach((i, index) => {
        if (row.skuGuid == i.skuGuid) {
          indexOf = index;
        }
      });
      if (indexOf >= 0) {
        this.editModel.itemList.splice(indexOf, 1);
      }
      this.handleItemChange();
    },
    handleItemGoodsChange(item) {
      if (item.surveyCount < 0) {
        item.surveyCount = 0;
      }
      if (item.surveyPrice < 0) {
        item.surveyPrice = 0;
      }
      if (item.costPrice < 0) {
        item.costPrice = 0;
      }
      item.totalAmount = Number(Number(item.surveyPrice * item.surveyCount).toFixed(2));
      item.costAmount = Number(Number(item.costPrice * item.surveyCount).toFixed(2));
      this.handleItemChange();
    },
    handleItemChange() {
      this.editModel.costAmount = Number(this.editModel.freightCost) || 0;
      this.editModel.totalAmount =
        (Number(this.editModel.freightAmount) || 0) -
        (Number(this.editModel.discountAmount) || 0);
      (this.editModel.itemList || []).forEach((item) => {
        if (item.surveyCount < 0) {
          item.surveyCount = 0;
        }
        if (item.surveyPrice < 0) {
          item.surveyPrice = 0;
        }
        if (item.costPrice < 0) {
          item.costPrice = 0;
        }
        item.totalAmount = Number(Number(item.surveyPrice * item.surveyCount).toFixed(2));
        item.costAmount = Number(Number(item.costPrice * item.surveyCount).toFixed(2));
        if (!item.isDelete) {
          this.editModel.totalAmount += Number(item.totalAmount);
          this.editModel.costAmount += Number(item.costAmount);
          this.editModel.totalAmount = Number(
            Number(this.editModel.totalAmount).toFixed(2)
          );
          this.editModel.costAmount = Number(
            Number(this.editModel.costAmount).toFixed(2)
          );
        }
      });
    },
    checkItemList() {
      let flag = true;
      this.editModel.itemList.forEach((i) => {
        if (!i.isDelete && i.goodsCount < 0) {
          flag = false;
        }
      });
      if (!flag) {
        this.error("清单列表数量不能小于0");
      }
      return flag;
    },
    submitClick() {
      if (!this.checkItemList()) {
        return;
      }
      this.$refs.form.validate((valid, data) => {
        if (valid) {
          this.editSubmit = true;
          this.requestApi("biz.warehouse.survey.info.update", this.editModel, {
            showError: true,
          })
            .then((resp) => {
              this.success("提交成功");
              this.$drawer.refreshDrawer();
              this.$drawer.backDrawer();
            })
            .finally(() => {
              this.editSubmit = false;
            });
        }
      });
    },
    handleModel() {
      // nothing
      this.handleItemChange();
    },
    fetchModel() {
      // 编辑
      this.loading = true;
      this.errorMsg = null;
      this.editModel = null;
      if (this.pageParams.guid) {
        return this.requestApi("biz.warehouse.survey.info.detail", {
          guid: this.pageParams.guid,
          storeGuid: this.pageParams.storeGuid,
        })
          .then((resp) => {
            return this.requestApi("biz.warehouse.survey.item.list", {
              surveyGuid: resp.data.guid,
              storeGuid: resp.data.storeGuid,
            }).then((listResp) => {
              this.editModel = Object.assign({}, defaultModel, resp.data, {
                itemList: (listResp.data.list || []).map((item) => {
                  item.surveyCount = item.surveyCount;
                  item.surveyPrice = item.surveyPrice || "";
                  item.costPrice = item.costPrice || "";
                  item.isDelete = 0;
                  return item;
                }),
              });
              this.handleModel();
            });
          })
          .catch((err) => {
            this.errorMsg = (err && err.msg) || (err && err.message) || "数据加载失败";
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.editModel = Object.assign({}, defaultModel);
        this.loading = false;
      }
    },
  },
  created() {
    this.fetchModel();
  },
};
</script>
